import React, { memo, useCallback } from "react";
import { compose } from "redux";
import { reduxForm } from "redux-form";
import { connect, useSelector, useDispatch } from "react-redux";

import validate from "validations";
import { forms, paths } from "utils/constants";
import SmartRender from "containers/SmartRender";
import Spinner, { styles } from "components/Spinner";
import { requestMNPReservationNumber } from "ducks/actions";
import {
  makeSelectThemeColors,
  makeSelectMinimumAge,
  makeSelectDateOptions,
  makeSelectMonthOptions,
  makeSelectYearOptions,
  makeSelectPageValidations,
  makeSelectPortoutFormInitialValues,
  makeSelectServiceInstanceNumber,
  makeSelectCurrentPhoneNumber,
  makeSelectFormValues,
  makeSelectIsFetchingData,
  makeSelectGuestOrder,
  makeSelectDeliveryDetailsItems
} from "ducks/selectors";
import { createStructuredSelector } from "reselect";
import { getDOBSecurityHeader, gotoUrl, pathWithChannel } from "utils/helpers";

const RequestPortOut = Component =>
  function Comp(props) {
    const dispatch = useDispatch();
    const accountNumber = useSelector(makeSelectServiceInstanceNumber());
    const msisdn = useSelector(makeSelectCurrentPhoneNumber());
    const dob = props?.formValues?.dob;

    const onSubmit = useCallback(() => {
      const headers = getDOBSecurityHeader(dob);
      const requestPayLoad = {
        accountNumber,
        msisdn
      };
      dispatch(
        requestMNPReservationNumber(
          headers,
          requestPayLoad,
          (result, errors) => {
            if (!errors) {
              setTimeout(() => {
                gotoUrl(pathWithChannel(paths.MANAGE_ORDER));
              }, 0);
            } else {
              console.log("Portout failed. ", result, errors);
            }
          }
        )
      );
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accountNumber, msisdn, dob]);

    if (props?.isFetchingDetails)
      return <Spinner size={200} sx={styles.fullPage} />;

    return <Component {...props} onSubmit={onSubmit} />;
  };

const mapStateToProps = createStructuredSelector({
  formValidations: makeSelectPageValidations(forms.REQUEST_PORTOUT_FORM),
  formValues: makeSelectFormValues(forms.REQUEST_PORTOUT_FORM),
  initialValues: makeSelectPortoutFormInitialValues(),
  isFetchingDetails: makeSelectIsFetchingData("requestMNPReservationNumber"),
  monthOptions: makeSelectMonthOptions(),
  dateOptions: makeSelectDateOptions(),
  yearOptions: makeSelectYearOptions(),
  minimumAge: makeSelectMinimumAge(),
  themeColors: makeSelectThemeColors(),
  order: makeSelectGuestOrder(),
  deliveryDetailsItems: makeSelectDeliveryDetailsItems()
});
const mapDispatchToProps = {};
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(
  withConnect,
  reduxForm({
    form: forms.REQUEST_PORTOUT_FORM,
    destroyOnUnmount: false,
    validate
  }),
  memo
)(RequestPortOut(SmartRender));
